module.exports = __webpack_public_path__ + "static/media/Lab_Partner_1_PCR_Product.703baa81.svg";